import { useParams, useNavigate } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import NewBumpForm from "../../components/bump/NewBumpForm";

export default function NewBump() {
    const { productId } = useParams<{ productId: string }>();
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/products/edit/${productId}?tab=bump`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Novo Order Bump"
                description="Criar novo order bump para o produto"
            />
            <PageBreadcrumb
                pageTitle="Novo Order Bump"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <NewBumpForm
                    productId={productId}
                    onSuccess={() => {
                        // Redirecionar para a página de edição do produto na aba de orderbumps
                        navigate(`/products/edit/${productId}?tab=bump`);
                    }}
                    onError={(error) => {
                        console.error("Erro ao criar orderbump:", error);
                    }}
                />
            </div>
        </>
    );
}